'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleId$() {
  this.c99 = null;
  this.c9a = false;
}
export { $c_Lpresto_types$RoleId$ as $c_Lpresto_types$RoleId$ };
$p = $c_Lpresto_types$RoleId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleId$;
/** @constructor */
function $h_Lpresto_types$RoleId$() {
}
export { $h_Lpresto_types$RoleId$ as $h_Lpresto_types$RoleId$ };
$h_Lpresto_types$RoleId$.prototype = $p;
$p.nL = (function() {
  if ((!this.c9a)) {
    this.c99 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c9a = true;
  }
  return this.c99;
});
var $d_Lpresto_types$RoleId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleId$, "presto.types$RoleId$", ({
  a13: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleId$ as $d_Lpresto_types$RoleId$ };
var $n_Lpresto_types$RoleId$;
function $m_Lpresto_types$RoleId$() {
  if ((!$n_Lpresto_types$RoleId$)) {
    $n_Lpresto_types$RoleId$ = new $c_Lpresto_types$RoleId$();
  }
  return $n_Lpresto_types$RoleId$;
}
export { $m_Lpresto_types$RoleId$ as $m_Lpresto_types$RoleId$ };
//# sourceMappingURL=presto.types$-Role-Id$.js.map
